// extracted by mini-css-extract-plugin
export var fadeInOut = "_redotech-redo-web-lib-save-indicator-save-indicator-fadeInOut";
export var icon = "_redotech-redo-web-lib-save-indicator-save-indicator-icon";
export var savedIndicator = "_redotech-redo-web-lib-save-indicator-save-indicator-saved-indicator";
export var savingIndicator = "_redotech-redo-web-lib-save-indicator-save-indicator-saving-indicator";
export var spin = "_redotech-redo-web-lib-save-indicator-save-indicator-spin";